// extracted by mini-css-extract-plugin
module.exports = {"footer":"src-components-page-upgrade-UpgradeLayout-module__footer--2mkIe","override":"src-components-page-upgrade-UpgradeLayout-module__override--2Tw_e"};